import { useState, useEffect } from 'react';
import ApiService from '../services/ApiService';

const AVAILABLE_FEATURES = [
  { key: 'placement-analysis', label: 'Placement Analysis', description: 'TV value from ClickHouse placement data, detailed exposures with image grid' },
  { key: 'tracked-accounts', label: 'Tracked Accounts', description: 'Search and track Facebook pages and Instagram accounts for earned media monitoring' },
  { key: 'agent-api', label: 'Agent API', description: 'Push this tenant\'s exposure metrics to ClickHouse and allow their AI agent read-only access via a scoped database credential' },
];

const AdminTenantFeatures = ({ tenantId, tenantName, onClose }) => {
  const [features, setFeatures] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await ApiService.getTenantFeatures(tenantId);
        setFeatures(res.data || {});
      } catch (err) {
        setError('Failed to load features');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [tenantId]);

  const handleToggle = (key) => {
    setFeatures(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await ApiService.updateTenantFeatures(tenantId, features);
      onClose();
    } catch (err) {
      setError('Failed to save features');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
        <div className="fc-spinner" />
      </div>
    );
  }

  return (
    <div>
      {error && <div className="fc-callout fc-callout-error" style={{ marginBottom: 12 }}>{error}</div>}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {AVAILABLE_FEATURES.map(feature => (
          <label
            key={feature.key}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 12,
              padding: '12px 16px',
              borderRadius: 8,
              border: '1px solid var(--border)',
              backgroundColor: features[feature.key] ? 'rgba(82, 152, 197, 0.1)' : 'transparent',
              cursor: 'pointer',
              transition: 'background-color 0.15s',
            }}
          >
            <input
              type="checkbox"
              checked={!!features[feature.key]}
              onChange={() => handleToggle(feature.key)}
              style={{ marginTop: 2 }}
            />
            <div>
              <div style={{ fontWeight: 600, color: 'var(--text-primary)', fontSize: 14 }}>{feature.label}</div>
              <div style={{ color: 'var(--text-secondary)', fontSize: 12, marginTop: 2 }}>{feature.description}</div>
            </div>
          </label>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
        <button className="modal-btn ghost" onClick={onClose}>Cancel</button>
        <button className="modal-btn primary" onClick={handleSave} disabled={saving} style={saving ? { opacity: 0.5 } : {}}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default AdminTenantFeatures;
